const MAP_KEYS = {
  GOOGLE_MAP_KEY: "AIzaSyDkjzfVAmJAm1i6AjEFAhc09slmha_WIaM",
};

const MAP_STYLES = {
  LIGHT_MAP_STYLE: [],
};

export { MAP_KEYS, MAP_STYLES };
